import { render, staticRenderFns } from "./TicketNew.vue?vue&type=template&id=4f1d01b7&scoped=true"
import script from "./TicketNew.vue?vue&type=script&lang=js"
export * from "./TicketNew.vue?vue&type=script&lang=js"
import style0 from "./TicketNew.vue?vue&type=style&index=0&id=4f1d01b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d01b7",
  null
  
)

export default component.exports